<template lang="pug">
.userItemComponent(:class="[componentClasses, `_${variant}`]")
  abstract-item-component(
    :user-item="userItem"
    :variant="variant"
    :with-shadow="withShadow"
    :show-favorite="showFavorite"
    :show-info="showInfo"
    :show-action-button="showActionButton"
    :show-buy-button="showBuyButton"
    :label-action-button="labelActionButton"
    :is-clickable="isClickable"
    :is-in-basket="isInBasket"
    @action:favorite-off="$emit('action:favorite-off')"
    @action:favorite-on="$emit('action:favorite-on')"
    @action:click-on-item="$emit('action:click-on-item')"
    @action:click-on-info="$emit('action:click-on-info')"
    @action:click-on-buy="$emit('action:click-on-buy')"
    @action:click-on-action="$emit('action:click-on-action')"
  )
    .contentWrapper

      slot(name="progress")

      .title {{ userItem.data.title }}

      .text(v-if="userItem.isBook")
        span.authors( v-html="userItem.book.authorsText" )

      .text(v-else-if="userItem.isVpr")
        span.tasksCount {{ userItem.vpr.countTasksText }}

</template>

<script>
import AbstractItemComponent from './UiAbstractItem'
import UserItem from '@/models/UserItem'
export default {
  components: {
    AbstractItemComponent
  },
  props: {
    userItem: {
      type: UserItem,
      required: true
    },
    showFavorite: {
      type: Boolean,
      default: true
    },
    withShadow: Boolean,
    showInfo: Boolean,
    showActionButton: Boolean,
    showBuyButton: Boolean,
    labelActionButton: {
      type: String,
      default: 'Заниматься'
    },
    // default || catalog
    variant: {
      type: String,
      default: 'default'
    },
    isClickable: {
      type: Boolean,
      default: true
    },
    isInBasket: Boolean
  },
  emits: [
    'action:favorite-off',
    'action:favorite-on',
    'action:click-on-item',
    'action:click-on-info',
    'action:click-on-buy',
    'action:click-on-action'
  ],
  computed: {
    componentClasses () {
      return {
        _book: this.userItem.isBook,
        _vpr: this.userItem.isVpr
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.userItemComponent
  width: 100%
  height: 100%
  display: flex
  flex-flow: column

  .contentWrapper
    flex: 1
    display: flex
    flex-flow: column

    > .title
      flex: 1
      margin-bottom: 4*$u
      @include font('h3')
      @media (max-width: $padWidth)
        @include font('t18-demibold')

    > .text
      @include font('t16-regular')
      color: $cDarkGrey
      margin-bottom: $u

  &._catalog
    .contentWrapper
      > .title
        @include font('t18-demibold')
        margin-bottom: 2.5*$u

      > .text
        @include font('t16-regular')
</style>
